import { withLocalState } from 'pyradux';
import WorkAreaContainer from './WorkArea.container';
import reducer from './WorkArea.reducer';
import WorkAreaSagas from './WorkArea.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'dynamicData',
  sagas: [WorkAreaSagas],
};

export default withLocalState(withLocalStateOptions, WorkAreaContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/index.js